import React from "react";
import { Outlet } from "react-router-dom";

const SuperAdminLayout = () => {
  return <Outlet />;
};

export default SuperAdminLayout;
